module.exports = __webpack_public_path__ + "img/leaves-2.43e5bd62.jpg";